import { type CanDeactivateFn } from '@angular/router';

import { AdminPropertyFormPage } from '@features/admin/admin-properties/admin-property-form.page';

export const adminPropertyFormCanDeactivate: CanDeactivateFn<AdminPropertyFormPage> = (component) => component.confirmDeactivate();
